// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16">
        <path fill="#999" fill-rule="evenodd" d="M5.333 0a5.335 5.335 0 0 1 5.334 5.333c0 .945-.26 1.852-.686 2.611l-4.351 7.89a.377.377 0 0 1-.297.166.35.35 0 0 1-.296-.167L.685 7.944A5.181 5.181 0 0 1 0 5.334 5.335 5.335 0 0 1 5.333 0zm0 7.333c1.111 0 2-.889 2-2 0-1.11-.889-2-2-2-1.11 0-2 .89-2 2 0 1.111.89 2 2 2z"/>
    </svg>
`
};

export const IconGtPin = () => <span dangerouslySetInnerHTML={icon} />;

export default IconGtPin;
